import React from 'react';
import { Card, CardTitle, CardText, Chip, TextField } from 'material-ui';
import {
  translate as t,
  ViewTitle,
  Restricted,
} from 'admin-on-rest';
import { connect } from 'react-redux';
import { getFormValues } from 'redux-form';
import { withRouter } from 'react-router';
import { get } from 'lodash';

import References from './References';
// import RichTextField from './fields/RichTextField';

import { regscape } from '../utils/StringUtils';
import { TranslatableField } from './fields/TranslatableField';

const FAQComponent = ({ choices: { faq }, user, queryFilter, positionFilter, ...props }) => (
  <div>
    {
      faq.filter((faqItem) => {
        if (user && user.superUser) {
          return true;
        }
        const permissions = positionFilter.map((position) => faqItem.positions.includes(position));
        return permissions.includes(true);
      })
        .filter((filteredFaq) => {
          if (!queryFilter) {
            return true;
          }

          const filteredTags = filteredFaq.tags.map((tag) => {
            const matchesTag = new RegExp( // build new Regular Expression instance
              regscape(queryFilter), // our search string
              'gi' // search [g]lobally and case [i]sensitive
            ).test(tag); // test this RegExp against our book title, returns boolean)
            return matchesTag;
          });
          return filteredTags.includes(true);
        })
        .map(({ question, answer, tags }) => (
          <Card style={{ marginTop: '5px' }} key={question}>
            <CardTitle style={{ paddingBottom: 0, fontSize: '20px', fontWeight: 'bold' }}>
              <TranslatableField {...props} record={{ question }} source="question" />
            </CardTitle>
            <CardText className="faq-viewer-item-container">
              <TranslatableField {...props} richText record={{ answer }} source="answer" />
            </CardText>
            {tags.map((tag) => <Chip key={`${tag}`} style={{ display: 'inline-block', margin: '5px' }}>{tag}</Chip>)}
          </Card>
        ))}
  </div>
);

class FAQ extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      filter: '',
      positions: [],
    };
  }

  componentWillMount = () => {
    this.getPositions(this.props.permissions);
  }

  getPositions = (permissions) => {
    const permissionArr = [];
    if (!this.props.user.superUser) {
      Object.keys(permissions)
        .forEach((key) => permissions[key].position
          .forEach((permission) => permissionArr.indexOf(permission) === -1 && permissionArr.push(permission)));
    }
    this.setState({ positions: permissionArr });
  }

  handleTextInputChange = (e) => {
    const { value } = e.target;
    this.setState({ filter: value });
  }

  render() {
    const { props } = this;
    const { location, translate } = this.props;
    const { filter, positions } = this.state;

    return (
      <Restricted authParams={{ route: '/faq-viewer' }} location={location}>
        <Card>
          <ViewTitle title="FAQ" />
          <div style={{ padding: '15px' }}>
            <TextField
              hintText={translate('search', { queryables: translate('tag') })}
              onChange={(e) => this.handleTextInputChange(e)}
              fullWidth
            />
            <References references={[{ name: 'faq' }]} {...props}>
              <FAQComponent positionFilter={positions} queryFilter={filter} {...props} />
            </References>
          </div>
        </Card>
      </Restricted>
    );
  }
}

const selector = getFormValues('record-form');

export default connect(
  (state) => ({ record: selector(state), user: get(state, 'auth.user'), permissions: get(state, 'auth.user.permissions') }), {}
)(withRouter(t(FAQ)));
